import React from 'react';
import config from '../../config';
import CollapsiblesGroup from './CollapsiblesGroup';
import { forDesktopOnly } from '../Common/Helper';
import regionsAndCountries from './Resources/RegionsAndCountries';
import { HTMLTrans } from '../Common/Translations';

const CountryLink = (props) => {
  const { name, url, openInNewWindow = true } = props;

  return (
    <div className="my-2 col-lg-3 col-6">
      <a href={`https://www.${url}/`} target={openInNewWindow ? '_blank' : '_self'}> {name} </a>
    </div>
  );
};

const { s3BucketUrl } = config;

const Image = forDesktopOnly(() => (
  <img src={`${s3BucketUrl}/home/img-select-country.jpg`}/>));

const Countries = (props) => {
  const { isMobile = false } = props;
  const collapsibles = regionsAndCountries.map(region => ({
    title: region.regionName,
    titleClass: 'ProximaNova-Bold text-primary text-uppercase pt-4',
    content: <div className="row">
      {region.countries.map((country, index) => (
        <CountryLink key={index} name={country.name} url={country.url}/>
      ))}</div>,
  }));

  return (
    <div className="row bg-white">
      <Image/>
      <div className="col ml-3">
        <div className="row">
          <p className="h2 my-4 col-10"><HTMLTrans id="navbar.countries_title">Select Your Country</HTMLTrans></p>
          <button type="button" className="close col" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <CollapsiblesGroup collapsibles={collapsibles} isMobile={isMobile}/>
      </div>
    </div>
  );
};

export default Countries;



// WEBPACK FOOTER //
// ./src/Nav/Countries.js